import { useDispatch } from 'react-redux';

import { Snippet } from '@distribute/shared/types';
import { snippetsModel } from '../../../../../../features/snippets';

import { editorLeftSidebarModel } from '../../../../model';
import { useTiptapEditor } from '../../../../../../entities/tiptap-editor';
import { useCallback } from 'react';

export const useInsertSnippet = () => {
  const dispatch = useDispatch();
  const { editor } = useTiptapEditor();

  return useCallback(
    (snippet: Snippet) => {
      dispatch(
        snippetsModel.actions.updateSnippetUsedCount({
          snippetId: snippet.id,
        })
      );
      dispatch(editorLeftSidebarModel.actions.setSelectedOption(null));

      editor
        ?.chain()
        .insertSnippet({ id: snippet.id, type: snippet.type })
        .focus()
        .run();
    },
    [dispatch, editor]
  );
};
